<template>
<div class="chapter">
<div class="inner_page">
<p class="h1l" id="d7e202321">Things to Remember </p>
<p class="ext" id="d7e202821">The end of a thing is better than its beginning; the patient in spirit is better than the proud in spirit.</p>
<p class="ext1" id="d7e203921">ECCLESIASTES 7:8 NKJV </p>
<p class="ext" id="d9t00021">A hot-tempered man stirs up dissension, but a patient man calms a quarrel.</p>
<p class="ext1" id="d7e206021">PROVERBS 15:18 NIV </p>
<p class="ext" id="d7e207521"><b>Patience means living out the belief that God orders everything for the spiritual good of his children.</b></p>
<p class="ext1" id="d7e209921"><b>—J. I. PACKER </b></p>
<p class="ext" id="d7e210821">We show we are servants of God by our pure lives, our understanding, patience, and kindness, by the Holy Spirit, by true love.</p>
<p class="ext1" id="d7e212221">2 CORINTHIANS 6:6 NCV </p>
<p class="ext" id="d7e213821"><b>The two most powerful warriors are patience and time.</b></p>
<p class="ext1" id="d7e215221"><b>—LEO TOLSTOY </b></p>
<p class="ext" id="d7e216721">The Lord is not slack concerning His promise, as some count slackness, but is longsuffering toward us, not willing that any should perish but that all should come to repentance.</p>
<p class="ext1" id="d7e218521">2 PETER 3:9 NKJV </p>
<p class="ext" id="d7e219921">For many years You had patience with them, and testified against them by Your Spirit in Your prophets. Yet they would not listen; therefore You gave them into the hand of the peoples of the lands.</p>
<p class="ext1" id="d7e221721">NEHEMIAH 9:30 NKJV </p>
<p class="ext" id="d7e223121">Rest in the Lord, and wait patiently for Him.</p>
<p class="ext1" id="d7e223921">PSALM 37:7 NKJV </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Inc_9781418557720_epub_c16_r1.vue?c316e272